import * as React from "react";
import { memo } from "react";
import SideBarComponent from "../../../components/store/layout/SideBarComponent";

function SideBarStore({
  isLoading,
  attributesAvailable,
  categoriesAvailable
}) {
  return (
    isLoading === false && (
      <SideBarComponent
        attributesAvailable={attributesAvailable}
        categoriesAvailable={categoriesAvailable}
      />
    )
  )
}



export default memo(SideBarStore);
